"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSTextArea = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importStar(require("react"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
/** @jsxRuntime classic */
/** @jsx jsx */
var react_2 = require("@emotion/react");
var Theme_1 = require("../../../../Theme");
var BDSTextArea_style_1 = require("./BDSTextArea.style");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
var array_utils_1 = require("../../../../utils/array.utils");
var BDSTooltip_1 = require("../../Components/BDSTooltip/BDSTooltip");
exports.BDSTextArea = react_1.default.forwardRef(function (props, ref) {
    var _a, _b, _c, _d;
    var _e = props.className, className = _e === void 0 ? '' : _e, _f = props.style, style = _f === void 0 ? {} : _f, limitLength = props.limitLength, curLength = props.curLength, _g = props.error, error = _g === void 0 ? false : _g, lengthUnit = props.lengthUnit, footerComponent = props.footerComponent, textAreaProps = props.textAreaProps, isAutoGrow = props.isAutoGrow, highlightProps = props.highlightProps, popupIconPosition = props.popupIconPosition;
    var _h = textAreaProps.className, textAreaClassName = _h === void 0 ? '' : _h, _j = textAreaProps.style, textAreaStyle = _j === void 0 ? {
        height: isAutoGrow ? '20px' : '100%',
    } : _j, _k = textAreaProps.disabled, disabled = _k === void 0 ? false : _k, value = textAreaProps.value;
    var theme = Theme_1.lightTheme;
    var textareaRef = react_1.useRef(null);
    var backdropRef = react_1.useRef(null);
    var highlightRef = react_1.useRef(null);
    var markPositionArr = react_1.useRef([]);
    var _l = react_1.useState(''), showPopupKey = _l[0], setShowPopupKey = _l[1];
    var isIconPositionBottom = react_1.useMemo(function () {
        return popupIconPosition === 'bottom-left' || popupIconPosition === 'bottom-right';
    }, [popupIconPosition]);
    var applyHighlights = function (text, targetRegex) {
        var index = 0;
        var tempMarkPositionArr = [];
        var isMatch = text.match(targetRegex);
        if (!isMatch)
            markPositionArr.current = [];
        return text.replaceAll(targetRegex, function (match, offset, string) {
            var _a;
            index += 1;
            var endOffset = offset + match.length;
            tempMarkPositionArr.push({
                index: index - 1,
                start: offset,
                end: endOffset,
            });
            markPositionArr.current = lodash_1.default.cloneDeep(tempMarkPositionArr);
            if ((_a = props === null || props === void 0 ? void 0 : props.highlightProps) === null || _a === void 0 ? void 0 : _a.handleValidHighlightText) {
                var isValid = props.highlightProps.handleValidHighlightText(match);
                if (!isValid) {
                    return "<mark class=\"remove-target\">" + match + "</mark>";
                }
            }
            return "<mark>" + match + "</mark>";
        });
    };
    var handleScroll = function () {
        if (backdropRef.current && textareaRef.current) {
            var _a = textareaRef.current, scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
            backdropRef.current.scrollTo({
                top: scrollTop,
                left: scrollLeft,
            });
        }
    };
    var handleOnKeyDown = function (event) {
        var _a;
        if (!lodash_1.default.isNil(highlightProps)) {
            var isKeyDownBackspace_1 = event.key === 'Backspace';
            var isKeyDownDelete_1 = event.key === 'Delete';
            if (isKeyDownBackspace_1 || isKeyDownDelete_1) {
                var cursorPosition_1 = ((_a = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current) === null || _a === void 0 ? void 0 : _a.selectionEnd) || 0;
                var curMarkPosition = markPositionArr.current.find(function (markPosition) {
                    var start = markPosition.start, end = markPosition.end;
                    if (isKeyDownBackspace_1) {
                        return cursorPosition_1 > start && cursorPosition_1 <= end;
                    }
                    if (isKeyDownDelete_1) {
                        return cursorPosition_1 >= start && cursorPosition_1 < end;
                    }
                    return cursorPosition_1 > start && cursorPosition_1 < end;
                });
                var isInCursorMarkPosition = !!curMarkPosition;
                if (!lodash_1.default.isNil(value)) {
                    if (textareaRef.current && curMarkPosition && isInCursorMarkPosition) {
                        var start = curMarkPosition.start, end = curMarkPosition.end;
                        if ((highlightRef === null || highlightRef === void 0 ? void 0 : highlightRef.current) && highlightRef.current.children) {
                            var index = curMarkPosition.index;
                            var curMarkEle = highlightRef.current.children[index];
                            if (curMarkEle.className === 'remove-target') {
                                if (highlightProps === null || highlightProps === void 0 ? void 0 : highlightProps.handleRemoveHighlightText) {
                                    // eslint-disable-next-line prefer-template
                                    var removedValue = value.substring(0, start) + '' + value.substring(end);
                                    highlightProps === null || highlightProps === void 0 ? void 0 : highlightProps.handleRemoveHighlightText(removedValue);
                                }
                            }
                            else {
                                curMarkEle.className = 'remove-target';
                            }
                            event.preventDefault();
                        }
                    }
                }
            }
        }
        if (textAreaProps.onKeyDown) {
            textAreaProps.onKeyDown(event);
        }
    };
    var handleOnKeyUp = function (event) {
        var _a, _b;
        if (!lodash_1.default.isNil(highlightProps)) {
            var isKeyUpLeftArrow = event.key === 'ArrowLeft';
            var startCursorPosition_1 = ((_a = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
            var endCursorPosition_1 = ((_b = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) || 0;
            var isDrag_1 = startCursorPosition_1 !== endCursorPosition_1;
            var curMarkPosition = markPositionArr.current.find(function (markPosition) {
                var start = markPosition.start, end = markPosition.end;
                if (isDrag_1) {
                    return startCursorPosition_1 >= start && endCursorPosition_1 <= end;
                }
                return startCursorPosition_1 > start && endCursorPosition_1 < end;
            });
            var isInCursorMarkPosition = !!curMarkPosition;
            if (!lodash_1.default.isNil(value)) {
                if (textareaRef.current && curMarkPosition && isInCursorMarkPosition) {
                    if (isKeyUpLeftArrow) {
                        textareaRef.current.selectionStart = curMarkPosition.start;
                        textareaRef.current.selectionEnd = curMarkPosition.start;
                    }
                    else {
                        textareaRef.current.selectionStart = curMarkPosition.end;
                        textareaRef.current.selectionEnd = curMarkPosition.end;
                    }
                }
            }
        }
        if (textAreaProps.onKeyUp) {
            textAreaProps.onKeyUp(event);
        }
    };
    var handleOnClick = function (event) {
        var _a;
        if (!lodash_1.default.isNil(highlightProps)) {
            var cursorPosition_2 = ((_a = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
            var curMarkPosition = markPositionArr.current.find(function (markPosition) {
                var start = markPosition.start, end = markPosition.end;
                return cursorPosition_2 > start && cursorPosition_2 < end;
            });
            var isInCursorMarkPosition = !!curMarkPosition;
            if (!lodash_1.default.isNil(value)) {
                if (textareaRef.current && curMarkPosition && isInCursorMarkPosition) {
                    textareaRef.current.selectionStart = curMarkPosition.end;
                }
            }
        }
        if (textAreaProps.onClick) {
            textAreaProps.onClick(event);
        }
    };
    // @ts-ignore
    react_1.useImperativeHandle(ref, function () { return ({
        getCurrentCursorPosition: function () {
            var _a;
            return (_a = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart;
        },
        closePopup: function () {
            setShowPopupKey('');
        },
    }); });
    react_1.useEffect(function () {
        if (!lodash_1.default.isNil(value) && (highlightProps === null || highlightProps === void 0 ? void 0 : highlightProps.targetRegex)) {
            var highlightText = applyHighlights(value, highlightProps.targetRegex);
            if (highlightRef.current)
                highlightRef.current.innerHTML = highlightText;
        }
    }, [value]);
    /* eslint-disable */
    // @ts-nocheck
    function mergeRefs(refs) {
        return function (value) {
            refs.forEach(function (ref) {
                if (typeof ref === 'function') {
                    ref(value);
                }
                else if (ref != null) {
                    ref.current = value;
                }
            });
        };
    }
    return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ style: style, className: className + " " + (disabled ? 'isDisabled' : '') + " " + (error ? 'isError' : ''), css: BDSTextArea_style_1.BGTextAreaCSS(theme, !lodash_1.default.isNil(highlightProps)) }, { children: [(props === null || props === void 0 ? void 0 : props.popupIconMenus) && (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [showPopupKey && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-textarea-popup-wrapper", style: ((_b = (_a = props === null || props === void 0 ? void 0 : props.popupComponents) === null || _a === void 0 ? void 0 : _a[showPopupKey]) === null || _b === void 0 ? void 0 : _b.style) || {} }, { children: (_d = (_c = props === null || props === void 0 ? void 0 : props.popupComponents) === null || _c === void 0 ? void 0 : _c[showPopupKey]) === null || _d === void 0 ? void 0 : _d.component }), void 0)),
                    props.popupIconMenus && props.popupIconMenus.length > 0 && !isIconPositionBottom && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-textarea-top-menu-container " + (props.popupIconPosition === 'top-right' ? 'right-container' : '') }, { children: props.popupIconMenus.map(function (popupIconMenu, index) { return (jsx_runtime_1.jsx(BDSTooltip_1.BDSTooltip, tslib_1.__assign({ title: (popupIconMenu === null || popupIconMenu === void 0 ? void 0 : popupIconMenu.tooltip) || '', placement: "top" }, { children: jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "font-icon-panel-wrapper", onClick: function () {
                                    setShowPopupKey(popupIconMenu.popupKey);
                                } }, { children: jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, tslib_1.__assign({}, popupIconMenu.fontIconProps), void 0) }), void 0) }), array_utils_1.getUniqKey("bg-textarea-top-icon-menu", index))); }) }), void 0))] }, void 0)),
            jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-textarea-textarea-wrapper" }, { children: [!lodash_1.default.isNil(highlightProps) && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "backdrop", ref: backdropRef, style: {
                            // textarea + bg-textarea-textarea-wrapper padding
                            height: (textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.current) ? textareaRef.current.clientHeight + 10 + "px" : '100%',
                        } }, { children: jsx_runtime_1.jsx("div", { className: "highlights", ref: highlightRef }, void 0) }), void 0)),
                    jsx_runtime_1.jsx("textarea", tslib_1.__assign({ ref: mergeRefs([ref, textareaRef]), className: textAreaClassName, style: textAreaStyle, disabled: disabled }, textAreaProps, { onScroll: handleScroll, onChange: function (event) {
                            if (isAutoGrow) {
                                setTimeout(function () {
                                    /* eslint-disable */
                                    event.target.style.cssText = 'height:auto; padding:0';
                                    event.target.style.cssText = 'height:' + event.target.scrollHeight + 'px';
                                }, 0);
                            }
                            if (textAreaProps.onChange) {
                                textAreaProps.onChange(event);
                            }
                        }, onFocus: function (event) {
                            if (isAutoGrow) {
                                setTimeout(function () {
                                    /* eslint-disable */
                                    event.target.style.cssText = 'height:auto; padding:0';
                                    event.target.style.cssText = 'height:' + event.target.scrollHeight + 'px';
                                }, 0);
                            }
                            if (textAreaProps.onFocus) {
                                textAreaProps.onFocus(event);
                            }
                        }, onKeyDown: handleOnKeyDown, onKeyUp: handleOnKeyUp, onClick: handleOnClick }), void 0),
                    !isIconPositionBottom && footerComponent && jsx_runtime_1.jsx(react_1.default.Fragment, { children: footerComponent }, void 0),
                    !isIconPositionBottom && !lodash_1.default.isNil(curLength) && !lodash_1.default.isNil(limitLength) && (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "max-length-wrapper", css: react_2.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n              font-size: 10px;\n              font-weight: normal;\n              font-stretch: normal;\n              font-style: normal;\n              letter-spacing: normal;\n              color: #626871;\n            "], ["\n              font-size: 10px;\n              font-weight: normal;\n              font-stretch: normal;\n              font-style: normal;\n              letter-spacing: normal;\n              color: #626871;\n            "]))) }, { children: [curLength, "/", limitLength, lengthUnit && jsx_runtime_1.jsx(react_1.default.Fragment, { children: lengthUnit }, void 0)] }), void 0))] }), void 0),
            props.popupIconMenus && props.popupIconMenus.length > 0 && isIconPositionBottom && (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-textarea-bottom-menu-container " + (popupIconPosition === 'bottom-right' ? 'right-container' : '') + " " + (footerComponent ? 'has-footer-component' : '') }, { children: [popupIconPosition === 'bottom-right' && footerComponent && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "footer-component" }, { children: footerComponent }), void 0)),
                    jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bottom-menu-wrapper " + (popupIconPosition === 'bottom-right' ? 'right-bottom-menu-wrapper' : '') }, { children: props.popupIconMenus.map(function (popupIconMenu, index) { return (jsx_runtime_1.jsx(BDSTooltip_1.BDSTooltip, tslib_1.__assign({ title: (popupIconMenu === null || popupIconMenu === void 0 ? void 0 : popupIconMenu.tooltip) || '', placement: "top" }, { children: jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "font-icon-panel-wrapper", onClick: function () {
                                    setShowPopupKey(popupIconMenu.popupKey);
                                } }, { children: jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, tslib_1.__assign({}, popupIconMenu.fontIconProps), void 0) }), void 0) }), array_utils_1.getUniqKey("bg-textarea-top-icon-menu", index))); }) }), void 0),
                    popupIconPosition === 'bottom-left' && footerComponent && (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "footer-component" }, { children: footerComponent }), void 0)),
                    isIconPositionBottom && !lodash_1.default.isNil(curLength) && !lodash_1.default.isNil(limitLength) && (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "max-length-wrapper has-bottom-icon", css: react_2.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n                font-size: 10px;\n                font-weight: normal;\n                font-stretch: normal;\n                font-style: normal;\n                letter-spacing: normal;\n                color: #626871;\n              "], ["\n                font-size: 10px;\n                font-weight: normal;\n                font-stretch: normal;\n                font-style: normal;\n                letter-spacing: normal;\n                color: #626871;\n              "]))) }, { children: [curLength, "/", limitLength, lengthUnit && jsx_runtime_1.jsx(react_1.default.Fragment, { children: lengthUnit }, void 0)] }), void 0))] }), void 0))] }), void 0));
});
var templateObject_1, templateObject_2;
